import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function NumberPreview({
  value
}) {
  return _jsx(WidgetPreviewContainer, {
    children: value
  });
}
NumberPreview.propTypes = {
  value: PropTypes.node
};
export default NumberPreview;